import coverBaltiptsy from "../../assets/tiptsy2.webp";

export interface Track {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  src: string;
  cover: string;
}

// Agrega futuras canciones aquí. El reproductor y la lista se actualizan automáticamente.
export const tracks: Track[] = [{
  id: "baltiptsy",
  title: "Baltiptsy",
  subtitle: "El Baile de la Tuza",
  description: "Una pieza festiva de música de viento mixe para escuchar, bailar y compartir.",
  src: "/audio/Baltiptsy.mp3",
  cover: coverBaltiptsy
}];
